import React, { ReactElement } from 'react'
import SectionContainer from '../SectionContainer'
import WebBrowsersIcon from 'images/integrations/web-browsers.svg'
import ItemContainer from '../ItemContainer'
import GoogleChrome from 'images/integrations/web-browsers/chrome.svg'
import MozillaFirefox from 'images/integrations/web-browsers/firefox.svg'
import MicrosoftEdge from 'images/integrations/web-browsers/edge.svg'
import Safari from 'images/integrations/web-browsers/safari.svg'
import Opera from 'images/integrations/web-browsers/opera.svg'
import Brave from 'images/integrations/web-browsers/brave.svg'
import Vivaldi from 'images/integrations/web-browsers/vivaldi.svg'

export default function WebBrowsersSection(): ReactElement {
  return (
    <SectionContainer isOrangeBlur sectionIcon={WebBrowsersIcon} title="Web Browsers">
      <ItemContainer
        icon={GoogleChrome}
        title="Google Chrome"
        learnMorePath="browsers-platform#chrome"
      />
      <ItemContainer
        icon={MozillaFirefox}
        title="Mozilla Firefox"
        learnMorePath="browsers-platform#firefox"
      />
      <ItemContainer
        icon={MicrosoftEdge}
        title="Microsoft Edge"
        learnMorePath="browsers-platform#edge"
      />
      <ItemContainer icon={Safari} title="Safari" />
      <ItemContainer icon={Opera} title="Opera" />
      <ItemContainer icon={Brave} title="Brave" />
      <ItemContainer icon={Vivaldi} title="Vivaldi" />
    </SectionContainer>
  )
}
